import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=6a4a56d1&scoped=true&lang=pug"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=6a4a56d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a56d1",
  null
  
)

export default component.exports